import React, { useState, useEffect } from 'react';
import { Button, Col, Container, Row } from "reactstrap";
import { Grid, _ } from 'gridjs-react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import { useHistory } from 'react-router-dom';
import { changeValidOfPremiumCode, deletePremiumCode, getPremiumCodes } from '../../helpers/api/premium/premium';

const PremiumCodeTable = () => {
    const [codes, setCodes] = useState([]);

    const history = useHistory();

    document.title = "Premium Codes";

    const getCodeList = async () => {
        try {
            setCodes([]);
            let response = await getPremiumCodes();
            if (!response.success) throw response.data;

            setCodes(response.data.map(code => {
                return [
                    code.id,
                    code.code,
                    code.monthCount,
                    code.usage,
                    (code.isValid) ? "Yes" : "No",
                ]
            }));
        } catch (error) {
            console.log(error);
        }
    }

    const handleClickGridItem = (e) => {
        e.preventDefault();
        let row = e.target.parentElement.parentElement.parentElement;
        let id = row.children[0].innerText;

        history.push("/premium-code-details", { params: { id, type: "INFORM" } });
    }

    const handleClickAdd = () => {
        history.push("/premium-code-details", { params: { type: "ADD" } });
    }

    const handleChangeActivity = async (e) => {
        try {
            e.preventDefault();
            let row = e.target.parentElement.parentElement.parentElement;
            let id = row.children[0].innerText;

            let item = codes.find(w => w[0] == id)[4];
            let activity;

            if (item == "Yes") activity = 0;
            else activity = 1;

            let response = await changeValidOfPremiumCode({ id, isValid: activity });
            if (!response.success) return console.log(response.data);

            await getCodeList();
        } catch (error) {
            console.log(error);
        }
    };

    const handleClickDelete = async (e) => {
        try {
            e.preventDefault();

            confirmAlert({
                title: 'Confirm to Delete',
                message: 'Are you sure to delete this premium code?',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: async () => {
                            let row = e.target.parentElement.parentElement.parentElement;
                            let id = row.children[0].innerText;

                            let response = await deletePremiumCode({ id });
                            if (!response.success) return console.log(response.data);

                            await getCodeList();
                        }
                    },
                    {
                        label: 'No'
                    }
                ]
            });
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getCodeList();
    }, []);

    return (
        <>
            <div className="page-content">
                <Row>
                    <Col xs="10" />
                    <Col xs="2">
                        <Button onClick={handleClickAdd} color="danger">Premium Code Ekle</Button>
                    </Col>
                </Row>
                <Container fluid={true}>
                    <React.Fragment>
                        <Grid
                            data={codes}
                            columns={[
                                "#", "Code", "Month Count", "Usage", "Is Valid",
                                {
                                    name: 'Actions',
                                    width: '200px',
                                    formatter: (cell) => _(
                                        <>
                                            <Button type='button' onClick={handleChangeActivity} className='btn btn-sm btn-warning'> Change Activity </Button>
                                            <Button type='button' onClick={handleClickGridItem} className='btn btn-sm btn-light'> Details </Button>
                                            <Button type='button' onClick={handleClickDelete} className='btn btn-sm btn-danger'> Delete </Button>
                                        </>
                                    )
                                }
                            ]}
                            search={true}
                            sort={true}
                            pagination={{ enabled: true, limit: 10 }}
                        />
                    </React.Fragment>
                </Container>
            </div>
        </>
    );
}

export default PremiumCodeTable;